import { useEffect, useState } from "react";
import {Box,Grid,GridItem,FormControl,FormLabel,Input,Select,Button,FormErrorMessage,} from "@chakra-ui/react";
import MyDiv from "./employment&Experience.style";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomToast } from "../../../../../components";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AutoCompleteInput from "../../../../../components/AutoCompleteInput/AutoCompleteInput";
import {EmploymentExperienceForm,EmploymentExperienceProps,IBusinessProcess,PayrollOption,schema,} from "./model";
import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";

const EmploymentExperience: React.FC<EmploymentExperienceProps> = ({ nextStep, prevStep, employment, setEmployment, employeeId, usCompanyId,}) => {
  const [loading, setLoading] = useState(false);
  const [payrollCompanyOptions, setPayrollCompanyOptions] = useState<PayrollOption[]>([]);
  const [businessProcess, setBusinessProcess] = useState<IBusinessProcess[]>([]);
  const [referenceOption, setReferenceOption] = useState<any[]>([]);
  const [managerOptions, setManagerOptions] = useState<{ label: string; id: number }[]>([]);
  const [teamLeadOptions, setTeamLeadOptions] = useState<{ label: string; id: number }[]>([]);
  const [isReferenceField, setIsReferenceField] = useState(false);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);

  const { handleSubmit, control, watch, setValue, formState: { errors }, reset,} = useForm<EmploymentExperienceForm>({
    defaultValues: {
      ...employment,
    },
    resolver: yupResolver(schema ),
  });

  useEffect(() => {
    if (payrollCompanyOptions.length && businessProcess.length) {
      reset({
        ...employment,
        // -: employment.experience ?? "",  
        // lastOrganisation: employment.lastOrganisation ?? "", 
      });
    }
  }, [employment, payrollCompanyOptions, businessProcess, reset]);

  const PayrollCompany = async () => {
    const response = await fetchApi( "DropDown/payrollCompany", "GET", null, "", "");
    if (response) setPayrollCompanyOptions(response);
  };
  const BusinessProcess = async () => {
    const response = await fetchApi( "DropDown/businessProcess", "GET", null, "", "");
    if (response) setBusinessProcess(response);
  };
  const ReferenceMast = async () => {
    const response = await fetchApi("DropDown/reference", "GET", null, "", "");
    if (response) setReferenceOption(response);
  };

  useEffect(() => {
    PayrollCompany();
    BusinessProcess();
    ReferenceMast();
  }, []);

  const onSubmit = async (data: EmploymentExperienceForm) => {
    try {
      if (!employeeId) {
        addToast({ message: "Employee ID not found", status: "error" });
        return;
      }
      setLoading(true);
      setEmployment(data);

      const payload = { ...data, employeeId };

      const response = await fetchApi( "Hrlense_Employee/EmploymentExperience", "POST", payload, null, "");
      if (response) {
        addToast({ message: response.message, status: "success" });
        nextStep();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleTeamLeadChange = async (value: string) => {
    if (value.length > 1) {
      const res = await fetchApi( "Hrlense_Employee/EmployeeList", "GET", null, `filter=${value}&assignedCompany=${(usCompanyId = 1)}`, "");

      if (res) {
        setTeamLeadOptions(
          res.map((emp: any) => ({
            id: emp.employeeID,
            label: emp.emp_Name,
          }))
        );
      }
    }
  };

  const handleManagerChange = async (value: string) => {
    if (value.length > 1) {
      const res = await fetchApi( "Hrlense_Employee/EmployeeList", "GET", null, `filter=${value}&assignedCompany=${(usCompanyId = 1)}`, "");

      if (res) {
        setManagerOptions(
          res.map((emp: any) => ({
            id: emp.employeeID,
            label: emp.emp_Name,
          }))
        );
      }
    }
  };

  return (
    <MyDiv>
      <Box m={6}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} gap={12}>
            {/* Left Column */}
            <GridItem>
              <FormControl mb={4} isInvalid={!!errors.payrollCompanyId} isRequired>
                <FormLabel>Payroll Company</FormLabel>
                <Controller
                  name="payrollCompanyId"
                  control={control}
                  render={({ field }) => (
                    <Select placeholder="Select payroll company" {...field}>
                      {payrollCompanyOptions.map((pay) => (
                        <option key={pay.id} value={pay.id}>
                          {pay.payroll_Company_Name}
                        </option>
                      ))}
                    </Select>
                  )}
                />
                <FormErrorMessage>
                  {errors.payrollCompanyId?.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl mb={4} isInvalid={!!errors.businessProcessId} isRequired>
                <FormLabel>Business Process</FormLabel>
                <Controller
                  name="businessProcessId"
                  control={control}
                  render={({ field }) => (
                    <Select placeholder="Select business process" {...field}>
                      {businessProcess.map((process) => (
                        <option
                          key={process.business_Process_Id}
                          value={process.business_Process_Id}
                        >
                          {process.business_Process_Name}
                        </option>
                      ))}
                    </Select>
                  )}
                />
                <FormErrorMessage>
                  {errors.businessProcessId?.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl mb={4} isInvalid={!!errors.experience}>
                <FormLabel>Experience (In Months)</FormLabel>
                <Controller
                  name="experience"
                  control={control}
                  render={({ field }) => (
                  <Input
                      type="number"
                      placeholder="Enter experience in month"
                      {...field}
                      maxLength={3}
                      onChange={(e) => {
                      let value = e.target.value;
                      // Sirf digits allow karo (0–9), baaki sab hata do
                      value = value.replace(/[^0-9]/g, "");
                      if (value.length > 3) {
                      value = value.slice(0, 3);
                      }
                      field.onChange(value);
                      }}
                      onKeyDown={(e) => {
                      // Prevent +, -, e, E, ., etc.
                      if (["-", "+", ".", "e", "E"].includes(e.key)) {
                      e.preventDefault();
                      }
                      }}
                      onPaste={(e) => {
                      // Prevent paste of non-numeric chars
                      const pasteData = e.clipboardData.getData("text");
                      if (!/^\d+$/.test(pasteData)) {
                      e.preventDefault();
                      }
                      }}
                    />
                  )}
                />
                <FormErrorMessage>
                  {errors.experience?.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl mb={4} isInvalid={!!errors.lastOrganisation} isRequired={Number(watch("experience")) > 0}>
                <FormLabel>Last Organisation Name</FormLabel>
                <Controller
                  name="lastOrganisation"
                  control={control}
                  render={({ field }) => (
                    <Input
                      placeholder="Enter Last Organisation Name"
                      {...field}
                      isDisabled={!watch("experience") || Number(watch("experience")) <= 0}
                    />
                  )}
                />
                <FormErrorMessage>
                  {errors.lastOrganisation?.message}
                </FormErrorMessage>
              </FormControl>

              <FormControl mb={4} isInvalid={!!errors.referenceId} isRequired>
                <FormLabel>Reference</FormLabel>
                <Controller
                  name="referenceId"
                  control={control}
                  render={({ field }) => (
                    <Select
                      placeholder="Select reference"
                      {...field}
                      onChange={(e) => {
                        const val = parseInt(e.target.value);
                        field.onChange(val);

                        const selectedRef = referenceOption.find(
                          (ref) => ref.id === val
                        );
                        if (
                          selectedRef?.reference === "No-Reference / Walk-In"
                        ) {
                          setIsReferenceField(false);
                        } else if (selectedRef?.reference === "N/A") {
                          setIsReferenceField(false);
                          setValue("referredBy", "");
                        } else {
                          setIsReferenceField(true);
                        }
                      }}
                    >
                      {referenceOption.map((ref) => (
                        <option key={ref.id} value={ref.id}>
                          {ref.reference}
                        </option>
                      ))}
                    </Select>
                  )}
                />
                <FormErrorMessage>
                  {errors.referenceId?.message}
                </FormErrorMessage>
              </FormControl>

              {isReferenceField && (
                <FormControl mb={4} isInvalid={!!errors.referredBy} isRequired>
                  <FormLabel>Referred By</FormLabel>
                  <Controller
                    name="referredBy"
                    control={control}
                    render={({ field }) => (
                      <Input
                        placeholder="Enter Referred by"
                        value={field.value || ""}
                        onChange={(e) => {
                          let value = e.target.value;
                          value = value.replace(/[^a-zA-Z\s]/g, "");
                          field.onChange(value);
                        }}
                      />
                    )}
                  />
                   <FormErrorMessage>
                     {errors.referredBy?.message}
                   </FormErrorMessage>
                 </FormControl>
                )}

            </GridItem>
            <GridItem>
              {/* Right Column */}
              <FormControl mb={4} isInvalid={!!errors.teamLeadId} isRequired>
                <FormLabel>Team Lead</FormLabel>
                <Controller
                  name="teamLeadName"
                  control={control}
                  render={({ field }) => (
                    <AutoCompleteInput
                      placeholder="Search Team Lead..."
                      value={field.value ?? ""}
                      onChange={(val: string) => {
                        field.onChange(val);
                        handleTeamLeadChange(val);
                      }}
                      options={teamLeadOptions}
                      loading={loading}
                      onSelect={(label, id) => {
                        field.onChange(label);
                        setValue("teamLeadId", id);
                      }}
                    />
                  )}
                />
              </FormControl>

              <FormControl mb={4} isInvalid={!!errors.managerId} isRequired>
                <FormLabel>Manager</FormLabel>
                <Controller
                  name="managerName"
                  control={control}
                  render={({ field }) => (
                    <AutoCompleteInput
                      placeholder="Search Manager..."
                      value={field.value ?? ""}
                      onChange={(val: string) => {
                        field.onChange(val);
                        handleManagerChange(val);
                      }}
                      options={managerOptions}
                      loading={loading}
                      onSelect={(label, id) => {
                        field.onChange(label);
                        setValue("managerId", id);
                      }}
                    />
                  )}
                />
              </FormControl>
            </GridItem>
          </Grid>

          <Box mt={6} display="flex" justifyContent="space-between">
            <Button onClick={prevStep} colorScheme="gray" leftIcon={<ArrowBackIcon boxSize={4} />}>Previous</Button>
            <Button type="submit" isLoading={loading} colorScheme="green" rightIcon={<ArrowForwardIcon boxSize={4} />}>Save & Next</Button>
          </Box>
        </form>
      </Box>
    </MyDiv>
  );
};

export default EmploymentExperience;
